import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex, Text, Tooltip } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'

import { useTranslation } from '@flecto/translations'
import { type CoreInsurance, type CoreItem } from '@flecto/types'
import { AvatarItem, Icon } from '@flecto/ui'

import { BadgeInsuranceStatus } from '../BadgeInsuranceStatus/BadgeInsuranceStatus'

export type CellNameProps = {
  insurance?: CoreInsurance
}

export function CellName({ insurance }: CellNameProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })
  const { copied, copy } = useClipboard({ timeout: 600 })

  return (
    <Flex align='center' gap='md' style={{ overflow: 'hidden' }}>
      <AvatarItem item={insurance?.item as CoreItem} />
      <Box maw={180} mt={-3}>
        <Box style={{ overflow: 'hidden' }}>
          <Text fw={500} truncate>
            {insurance?.item?.title}
          </Text>
          <Tooltip
            label={`${t('label_policy_number')}: ${insurance?.policy_number}`}
            withinPortal
          >
            <Text
              c='dimmed'
              size='sm'
              truncate
              style={{ cursor: 'pointer' }}
              onClick={() => copy(insurance?.policy_number)}
            >
              <Icon icon={copied ? faCheck : faCopy} size='xs' mr='xs' />
              {t('label_policy_number')}: {insurance?.policy_number}
            </Text>
          </Tooltip>
        </Box>
        <Flex gap='sm' align='center' mt='xs'>
          <BadgeInsuranceStatus insurance={insurance} ml={-4} />
        </Flex>
      </Box>
    </Flex>
  )
}
